import { useEffect, useState } from "react";
import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import { Outlet, useLocation, useNavigate } from "react-router";

export default function AboutPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [content, setContent] = useState();

  const redirectTo = () => {
    if (location.pathname === "/about") {
      navigate("/about/essentials");
    }
  };

  useEffect(() => {
    redirectTo();
    setContent(location.pathname);
  }, [location.pathname]);

  return (
    <section className="about-page">
      <PagesHeader>
        <strong>Über das Programm</strong>
      </PagesHeader>
      <div className="tab-navigation">
        <div
          className={`tab-navigation-left ${
            content === "/about/essentials" ? "active" : ""
          }`}
          onClick={() => navigate("/about/essentials")}
        >
          Grundlegende Informationen
        </div>
        <div
          className={`tab-navigation-right ${
            content === "/about/faq" ? "active" : ""
          }`}
          onClick={() => navigate("/about/faq")}
        >
          FAQ
        </div>
      </div>
      <div className="about-page-content">
        <Outlet />
      </div>
    </section>
  );
}
